/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Bryan Sheranian <bryan.sheranian@deliciousai.com>
 */

import { gql } from '@apollo/client'
import { PERMISSION_FRAGMENT } from './PermissionFragment'

export const GROUP_FRAGMENT = gql`
  fragment Group on Group {
    id
    name
    permissions {
      ...Permission
    }
    customerRoles
  }
  ${PERMISSION_FRAGMENT}
`
